import { LOCAL_STORAGE } from 'app/commons/constants'
import { hideLoading, showLoading } from 'app/commons/helpers/loadingUtils'
import * as Utils from 'app/commons/helpers/utils'
import authApi from 'app/services/authApi'
import * as authActions from 'app/store/auth/authAction'
import { getAndCheckTokenCaptCha } from 'app/utils/authentication'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import * as Yup from 'yup'

import React, { Component } from 'react'
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'

import { validatePhoneNumberWithCountry } from '../../commons/helpers'
import InputPhone from '../InputPhone'
import './style.scss'

Yup.addMethod(Yup.string, 'phoneValidate', (message, countryCode) =>
  Yup.string()
    .required('signup.phoneRequired')
    .test('phoneValidate', message, (value) => {
      if (value) {
        return validatePhoneNumberWithCountry(value, countryCode)
      }
      return value
    })
)

const EditPhoneSchema = Yup.object().shape({
  phone: Yup.string().phoneValidate('signup.phoneInvalid', 'vn'),
})

class SmsVerify extends Component {
  isClickSendCode = false
  isClickVerifyCode = false
  isClickResendCode = false

  constructor() {
    super()
    this.state = {
      verificationCode: '',
      phone: '',
      countryDialCode: '',
      countryCode: 'id',
      action: 1,
    }
  }

  componentDidMount() {
    const isJustCreateAccount = JSON.parse(localStorage.getItem(LOCAL_STORAGE.JUST_CREATED_ACCOUNT))
    localStorage.removeItem(LOCAL_STORAGE.JUST_CREATED_ACCOUNT)
    const action = isJustCreateAccount ? 3 : 1

    this.setState({ action: action }, () => {
      if (action === 1) {
        this.verifyCodeInput.focus()
      }
    })
    this.separateFullPhone()
  }
  separateFullPhone() {
    const { accounts } = this.props
    if (accounts) {
      const dialCode = Utils.getDialCodeWithCountryCode(accounts.country_code)
      const countryDialCode = dialCode

      const phoneNotDialCode = accounts.phone.slice(`+${countryDialCode}`.length, accounts.phone.length)
      this.setState({
        phone: phoneNotDialCode,
        countryDialCode,
        countryCode: accounts.country_code,
      })

      EditPhoneSchema.phone = Yup.string().phoneValidate('signup.phoneInvalid', accounts.country_code)
    } else {
      const { closePopup } = this.props
      closePopup()
    }
  }

  onCountryCodeValueChanged(country) {
    const phoneValidateObject = Yup.string().phoneValidate('signup.phoneInvalid', country.iso2)
    EditPhoneSchema.fields.phone = phoneValidateObject
    this.setState({
      countryDialCode: country.dialCode,
      countryCode: country.iso2,
    })
  }

  async onClickSavePhoneNumber() {
    const { phone, countryCode, countryDialCode } = this.state
    const { t, enableCaptchaVerification, googleReCaptchaProps } = this.props
    showLoading()
    try {
      let xRecaptchaToken
      if (enableCaptchaVerification) {
        const executeRecaptcha = googleReCaptchaProps?.executeRecaptcha
        xRecaptchaToken = await getAndCheckTokenCaptCha(executeRecaptcha, 'phone_changed')
      }
      const result = await authApi.updateCustomerMe(
        {
          phone: `+${countryDialCode}${phone}`,
          country_code: countryCode,
        },
        xRecaptchaToken
      )
      if (result?.object?.id) {
        this.setState({
          action: 1,
        })
      } else {
        toast.error(result?.error || t('common.viewPhoneNumber.invalidPhoneNumber'))
      }
    } catch (error) {
      console.debug(error)
    } finally {
      hideLoading()
    }
  }

  onClickEditPhoneNumber() {
    this.setState({ action: 2 })
  }

  async callApiResendCode() {
    const { t, enableCaptchaVerification, googleReCaptchaProps } = this.props
    let xRecaptchaToken
    if (enableCaptchaVerification) {
      const executeRecaptcha = googleReCaptchaProps?.executeRecaptcha
      xRecaptchaToken = await getAndCheckTokenCaptCha(executeRecaptcha, 'resend_sms_token')
    }
    const result = await authApi.resendCode(xRecaptchaToken)
    if (result.error) {
      toast.error(result.error)
    } else {
      toast.success(t('common.viewPhoneNumber.sendSmsVerify'))
    }
  }

  async handleOnChange(e) {
    const valueCode = e.target.value
    if (valueCode.length >= 4) {
      const { actions, closePopup, enableCaptchaVerification, googleReCaptchaProps } = this.props
      let xRecaptchaToken
      if (enableCaptchaVerification) {
        const executeRecaptcha = googleReCaptchaProps?.executeRecaptcha
        xRecaptchaToken = await getAndCheckTokenCaptCha(executeRecaptcha, 'verify_sms_token')
      }
      actions.handleCheckVerificationCode({
        verificationCode: valueCode,
        xRecaptchaToken,
        callback: () => {
          closePopup()
        },
      })
      this.setState({
        verificationCode: '',
      })
    } else {
      this.setState({
        verificationCode: valueCode,
      })
    }
  }

  renderDot() {
    const { verificationCode } = this.state
    const boxDots = []
    for (let i = 0; i < 4 - verificationCode.length; i++) {
      boxDots.push(<span key={`key-dot-${i}`} />)
    }
    return boxDots
  }

  renderNumber() {
    const { verificationCode } = this.state
    return (
      <div className="sms-verify--box">
        {verificationCode &&
          verificationCode.split('').map((currentValue, index) => (
            <span key={`verify-${index}`} className="sms-verify--box__code">
              {currentValue}
            </span>
          ))}
        {this.renderDot()}
      </div>
    )
  }

  renderSmsVerifyActionVerificationCode() {
    const { verificationCode } = this.state
    const { t } = this.props
    return (
      <>
        <div className="header mt10">{t('common.viewPhoneNumber.verificationCode')}</div>
        <div className="sms-verify--second__text">{t('common.verifyCode.verifyCodeDescriptionMessage')}</div>
        <div className="sms-verify--number">
          {this.renderNumber()}
          <input
            onChange={(e) => this.handleOnChange(e)}
            value={verificationCode}
            type="text"
            ref={(verifyCodeInput) => {
              this.verifyCodeInput = verifyCodeInput
            }}
          />
        </div>
        <div className="sms-verify--action">
          <button
            type="button"
            className="Button transparent h40 fs17"
            onClick={() => {
              this.onClickEditPhoneNumber()
            }}
          >
            {t('common.viewPhoneNumber.editPhoneNumberButton')}
          </button>
          <button
            type="submit"
            className="Button green h40 fs17"
            onClick={() => {
              this.callApiResendCode()
            }}
          >
            {t('common.viewPhoneNumber.sendCodeButton')}
          </button>
        </div>
      </>
    )
  }

  renderEditPhoneNumber() {
    const { t, accounts } = this.props
    const { phone } = this.state
    return (
      <div className="edit-number">
        <div className="header">{t('common.viewPhoneNumber.editPhoneNumberButton')}</div>
        <div className="form-row m-auto">
          <div className="w-100">
            <InputPhone
              type="text"
              name="phone"
              id="phone"
              defaultCountryValue={accounts.country_code}
              className="form-control"
              value={phone}
              onChange={(value) => {
                this.setState({
                  phone: value,
                })
              }}
              onCountryCodeValueChanged={(country) => {
                this.onCountryCodeValueChanged(country)
              }}
            />
          </div>
        </div>
        <div className="mt20">
          <button
            type="submit"
            className="Button h40 green w-100 fs17"
            onClick={() => {
              this.onClickSavePhoneNumber()
            }}
          >
            {t('common.viewPhoneNumber.confirm')}
          </button>
        </div>
      </div>
    )
  }

  renderWelcomeToTheRevolution() {
    const { t, accounts } = this.props
    return (
      <>
        <div className="header mt10">{t('common.verifyCode.welcomeToRevolution')}</div>
        <div className="sms-verify--second__text">
          {t('common.verifyCode.sendSmsVerificationCode', { phone: accounts?.phone })}
          <br />
          {t('common.verifyCode.pleaseUseAPasscode')}
        </div>
        <div className="sms-verify--action">
          <button
            type="button"
            className="Button transparent h40 fs17"
            onClick={() => {
              this.onClickEditPhoneNumber()
            }}
          >
            {t('common.viewPhoneNumber.editPhoneNumberButton')}
          </button>
          <button
            type="submit"
            className="Button green h40 fs17"
            onClick={() => {
              this.setState({ action: 1 })
            }}
          >
            {t('common.ok')}
          </button>
        </div>
      </>
    )
  }
  render() {
    const { action } = this.state
    return (
      <div className="popup-auth top60">
        <div className="auth-body sms-verify">
          {action === 1 && this.renderSmsVerifyActionVerificationCode()}
          {action === 2 && this.renderEditPhoneNumber()}
          {action === 3 && this.renderWelcomeToTheRevolution()}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  accounts: state.auth.login.accounts,
  enableCaptchaVerification: state.configuration?.data?.enable_captcha_verification,
})

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...authActions }, dispatch),
})

SmsVerify.propTypes = {
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
  t: PropTypes.func.isRequired,
  closePopup: PropTypes.func.isRequired,
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(withGoogleReCaptcha(SmsVerify)))
